export enum ContainerJobItemStatusEnum {
  Active = 1,
  Cancelled = 2,
  Completed = 3,
  Billed = 4,
  Subcontractor = 5
}
